import Vue from 'vue'
import Router from 'vue-router'

import pageno from '@/components/404';
import login from '@/components/login/index';
import bianma from '@/components/bianma';

const config = require('@/components/Global');
Vue.use(Router)

const router = new Router({
    // mode: 'history',
    // base: process.env.BASE_URL,
  routes: [
    
  
    {
      path: '/',
      name: '/',
      component: bianma,
      meta:{
        title:'税收分类编码查询,商品发票开票编码在线查询平台-华思智能编码'
      }
    },
    {
      path: '/login',
      name: '/ogin',
      component: login,
      meta:{
        title:'税收分类编码查询,商品发票开票编码在线查询平台-华思智能编码'
      }
    },
   
    {
      path: '/404',
      component: pageno,
      hidden: true
    },
    // {
    //   path: "*", // 此处需特别注意置于最底部
    //   redirect: "/404"
    // }
  ],

});
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {

  //console.log(config.default.token||sessionStorage.getItem("storetoken") );
  if(to.meta.title) {
   
    document.title = to.meta.title
  }

  
  
    next();
  
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js